/* eslint-disable */
export enum FinnairPhoneType {
  MOBILE = 'MOBILE',
  LANDLINE = 'LANDLINE',
  EMERGENCY = 'EMERGENCY'
}

